import { BroadcastChannel } from "broadcast-channel";
import React from "react";
import styled, { css } from "styled-components";

import { OnboardingContainer } from "../components/login/OnboardingElements";
import { Flex } from "../hex-components/Flex";
import { BROADCAST_CHANNEL_NAMES } from "../hooks/useListenToBroadcastChannnel";
import { useOnInitialMount } from "../hooks/useOnInitialMount";
import { useQueryParams } from "../route/routes";

const StyledFlex = styled(Flex).attrs({
  justify: "center",
})`
  width: 100%;
  height: 100%;
`;

const ErrorView = React.memo(function ErrorView({ error }: { error: string }) {
  return <StyledFlex>{error}</StyledFlex>;
});

const SuccessView = React.memo(function SuccessView({
  mcpServerConnectionId,
}: {
  mcpServerConnectionId: string;
}) {
  useOnInitialMount(async () => {
    const mcpServerOauthEvents = new BroadcastChannel(
      BROADCAST_CHANNEL_NAMES.MCP_OAUTH_CALLBACK,
    );
    await mcpServerOauthEvents.postMessage(mcpServerConnectionId);
    await mcpServerOauthEvents.close();
  });

  return (
    <StyledFlex>
      Successfully connected! It is now safe to close this window.
    </StyledFlex>
  );
});

export const McpServerOauthResultView = React.memo(
  function McpServerOauthResultView() {
    const queryParams = useQueryParams();

    const error =
      queryParams.get("error") ??
      "An error occurred while connecting to the MCP server";
    const mcpServerConnectionId = queryParams.get("mcpServerConnectionId");

    return (
      <OnboardingContainer
        css={css`
          width: 100%;
          height: 100%;
        `}
      >
        {mcpServerConnectionId ? (
          <SuccessView mcpServerConnectionId={mcpServerConnectionId} />
        ) : (
          <ErrorView error={error} />
        )}
      </OnboardingContainer>
    );
  },
);
